var map = {
	"./averageGrossSalaryForThisMonth.png": "def8",
	"./averageLaborCostForThisMonth.png": "4ed6",
	"./averageNetSalaryForThisMonth.png": "48ac",
	"./custom-report-empty.png": "f95f",
	"./custom-report.png": "60e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5154";